import loginIcon from './svg/login.svg'
import printerIcon from './svg/printer.svg'
import addUserIcon from './svg/add-user.svg'
import addCircleIcon from './svg/add-circle.svg'
import editIcon from './svg/edit.svg'
import removeCircleIcon from './svg/remove-circle.svg'
import starIcon from './svg/star.svg'
import starOutlineIcon from './svg/star-outline.svg'
import documentsIcon from './svg/documents.svg'
import checkmarkIcon from './svg/checkmark.svg'
import informationCircleIcon from './svg/information-circle.svg'
import closeIcon from './svg/close.svg'
import noteIcon from './svg/note.svg'
import trashIcon from './svg/trash.svg'
import downloadIcon from './svg/download.svg'
import arrowDownIcon from './svg/arrow-down.svg'

import almostIcon from './svg/almost.svg'
import calendarIcon from './svg/calendar.svg'
import copyIcon from './svg/copy.svg'
import createIcon from './svg/create.svg'
import historyIcon from './svg/history.svg'
import infoIcon from './svg/info.svg'
import removeRequestIcon from './svg/remove-request-icon.svg'
import seenIcon from './svg/seen.svg'
import unseenIcon from './svg/unseen.svg'
import removeIcon from './svg/remove.svg'
import waitingIcon from './svg/waiting.svg'
import warningIcon from './svg/warning.svg'

import plusIcon from './svg/plus.svg'
import fileImportIcon from './svg/file-import.svg'

import arrowDownCircleIcon from './svg/arrow-down-circle.svg'
import removePersonIcon from './svg/remove-person.svg'
import removePersonCircleIcon from './svg/remove-person-circle.svg'
import exitIcon from './svg/exit.svg'
import cloneIcon from './svg/clone.svg'
import bellIcon from './svg/bell.svg'
import infoCardIcon from './svg/info-card.svg'
import keyIcon from './svg/key.svg'
import pencilIcon from './svg/pencil.svg'
import noteFilledIcon from './svg/note-filled.svg'
import bulletIcon from './svg/bullet.svg'

import circleCheckRegularIcon from './svg/circle-check-regular.svg'
import circleDotRegularIcon from './svg/circle-dot-regular.svg'
import circleNotchRegularIcon from './svg/circle-notch-solid.svg'
import creativeCommonsNdIcon from './svg/creative-commons-nd.svg'
import checkmarkCircleIcon from './svg/icon-checkmark.svg'
import circleExclamationSolidIcon from './svg/circle-exclamation-solid.svg'
import circleDotTruckRegular from './svg/circle-dot-truck-regular.svg'

import phoneIcon from './svg/phone.svg'
import desktopIcon from './svg/desktop.svg'
import questionIcon from './svg/question.svg'
import doctorIcon from './svg/doctor.svg'

export const login = loginIcon
export const printer = printerIcon
export const addUser = addUserIcon
export const addCircle = addCircleIcon
export const edit = editIcon
export const removeCircle = removeCircleIcon
export const star = starIcon
export const starOutline = starOutlineIcon
export const documents = documentsIcon
export const checkmark = checkmarkIcon
export const informationCircle = informationCircleIcon
export const close = closeIcon
export const note = noteIcon
export const trash = trashIcon

export const almost = almostIcon
export const arrowDown = arrowDownIcon
export const calendar = calendarIcon
export const copy = copyIcon
export const create = createIcon
export const download = downloadIcon
export const history = historyIcon
export const info = infoIcon
export const removeRequest = removeRequestIcon
export const seen = seenIcon
export const unseen = unseenIcon
export const remove = removeIcon
export const waiting = waitingIcon
export const warning = warningIcon

export const arrowDownCircle = arrowDownCircleIcon
export const removePerson = removePersonIcon
export const removePersonCircle = removePersonCircleIcon
export const exit = exitIcon
export const clone = cloneIcon

export const plus = plusIcon
export const bell = bellIcon
export const infoCard = infoCardIcon
export const key = keyIcon
export const pencil = pencilIcon
export const noteFilled = noteFilledIcon
export const bullet = bulletIcon

export const phone = phoneIcon
export const desktop = desktopIcon
export const question = questionIcon
export const doctor = doctorIcon
export const fileImport = fileImportIcon

//state icons
export const circleCheckRegular = circleCheckRegularIcon
export const circleDotRegular = circleDotTruckRegular
export const circleDotCircleRegular = circleDotRegularIcon
export const circleNotchRegular = circleNotchRegularIcon
export const creativeCommonsNd = creativeCommonsNdIcon
export const checkmarkCircle = checkmarkCircleIcon
export const circleExclamationSolid = circleExclamationSolidIcon

/**
 * array for mapping icon in showcase page
 */
export const ALL_ICONS = [
	{
		name: 'printer',
		icon: printer,
		tags: ['printer', 'fax']
	},
	{
		name: 'login',
		icon: login,
		tags: ['login']
	},
	{
		name: 'addUser',
		icon: addUser,
		tags: ['addUser', 'user']
	},
	{
		name: 'edit',
		icon: edit,
		tags: ['edit', 'pen', 'pencil']
	},
	{
		name: 'removeCircle',
		icon: removeCircle,
		tags: ['removeCircle']
	},
	{
		name: 'star',
		icon: star,
		tags: ['star']
	},
	{
		name: 'starOutline',
		icon: starOutline,
		tags: ['starOutline']
	},
	{
		name: 'documents',
		icon: documents,
		tags: ['documents', 'copy']
	},
	{
		name: 'clone',
		icon: clone,
		tags: ['clone', 'copy']
	},
	{
		name: 'checkmark',
		icon: checkmark,
		tags: ['checkmark']
	},
	{
		name: 'plus',
		icon: plus,
		tags: ['plus', 'add', 'create']
	},
	{
		name: 'informationCircle',
		icon: informationCircle,
		tags: ['informationCircle']
	},
	{
		name: 'note',
		icon: note,
		tags: ['note', 'document']
	},
	{
		name: 'noteFilled',
		icon: noteFilled,
		tags: ['noteFilled', 'document', 'filled']
	},
	{
		name: 'almost',
		icon: almost,
		tags: ['almost', 'half', 'semicircle']
	},
	{
		name: 'arrowDown',
		icon: arrowDown,
		tags: ['arrowDown', 'arrow', 'up']
	},
	{
		name: 'calendar',
		icon: calendar,
		tags: ['calendar', 'date', 'day', 'month', 'year']
	},
	{
		name: 'copy',
		icon: copy,
		tags: ['copy', 'papers', 'book']
	},
	{
		name: 'create',
		icon: create,
		tags: ['create', 'plus', 'circle']
	},
	{
		name: 'download',
		icon: download,
		tags: ['download', 'arrow', 'down']
	},
	{
		name: 'history',
		icon: history,
		tags: ['history', 'chart', 'cube']
	},
	{
		name: 'info',
		icon: info,
		tags: ['info', 'i', 'circle']
	},
	{
		name: 'removeRequest',
		icon: removeRequest,
		tags: ['removeRequest', 'delete', 'trash', 'circle']
	},
	{
		name: 'seen',
		icon: seen,
		tags: ['seen', 'eye', 'crossed', 'line']
	},
	{
		name: 'remove',
		icon: remove,
		tags: ['remove', 'circle', 'x', 'delete']
	},
	{
		name: 'waiting',
		icon: waiting,
		tags: ['waiting', 'hours', 'clock', 'time']
	},
	{
		name: 'warning',
		icon: warning,
		tags: ['warning', 'exclamation', 'mark', 'triangle']
	},
	{
		name: 'arrowDownCircle',
		icon: arrowDownCircle,
		tags: ['arrowDownCircle', 'arrow', 'down', 'circle']
	},
	{
		name: 'removePerson',
		icon: removePerson,
		tags: ['removePerson', 'minus', 'person', 'remove']
	},
	{
		name: 'removePersonCircle',
		icon: removePersonCircle,
		tags: ['removePersonCircle', 'minus', 'person', 'remove', 'circle']
	},
	{
		name: 'exit',
		icon: exit,
		tags: ['arrow', 'exit', 'remove', 'cube']
	},
	{
		name: 'bell',
		icon: bell,
		tags: ['bell', 'notification', 'ring']
	},
	{
		name: 'infoCard',
		icon: infoCard,
		tags: ['infoCard', 'card', 'information']
	},
	{
		name: 'key',
		icon: key,
		tags: ['key', 'lock', 'unlock']
	},
	{
		name: 'pencil',
		icon: pencil,
		tags: ['pencil', 'edit', 'pen']
	},
	{
		name: 'bullet',
		icon: bullet,
		tags: ['bullet', 'list', 'dot']
	},
	{
		name: 'circleCheckRegular',
		icon: circleCheckRegular,
		tags: ['circleCheckRegular', 'done', 'ok', 'circle', 'check']
	},
	{
		name: 'circleDotRegular',
		icon: circleDotRegular,
		tags: ['circleDotRegular', 'car', 'truck', 'circle', 'dot']
	},
	{
		name: 'circleDotCircleRegular',
		icon: circleDotCircleRegular,
		tags: ['circleDotCircleRegular', 'circle', 'circle', 'dot']
	},
	{
		name: 'circleNotchRegular',
		icon: circleNotchRegular,
		tags: ['circleNotchRegular', 'notch', 'solid', 'circle', 'space']
	},
	{
		name: 'creativeCommonsNd',
		icon: creativeCommonsNd,
		tags: ['creativeCommonsNd', 'common', 'regular', 'circle', 'full']
	},
	{
		name: 'checkmarkCircle',
		icon: checkmarkCircle,
		tags: ['checkmarkCircle', 'check', 'ok', 'done', 'full']
	},
	{
		name: 'circleExclamationSolid',
		icon: circleExclamationSolid,
		tags: ['circleExclamationSolid', 'exclamatio', 'error', 'mark', 'full']
	},
	{
		name: 'phone',
		icon: phone,
		tags: ['phone', 'mobile', 'call']
	},
	{
		name: 'fileImport',
		icon: fileImport,
		tags: ['fileImport', 'import', 'file']
	}
]
